import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Utils } from 'src/app/core/resources/utils';
import { CompaniesService } from '../list-companies.service';
import { SnackBarService } from 'src/app/core/services/snackBar.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { CostCenter } from 'src/app/core/interfaces/costCenter';
import { Company } from 'src/app/core/interfaces/company';
import { Fmt } from 'src/app/core/messages/fmt';
import { ServiceMessages } from 'src/app/core/messages/service-messages.enum';

@Component({
  selector: 'app-cost-center-form',
  templateUrl: './cost-center-form.component.html',
  styleUrls: ['./cost-center-form.component.scss']
})
export class CostCenterFormComponent implements OnInit {

  form: FormGroup;
  constructor(
    public dialogRef: MatDialogRef<CostCenterFormComponent>,
    public utils: Utils,
    private companiesService: CompaniesService,
    private snackBarService: SnackBarService,
    public spinner: NgxSpinnerService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      nitCompany;
      nameCompany;
      transportCompanyId?: string;
    }
  ) { }

  ngOnInit() {
    this.initForm();
  }

  initForm() {
    this.form = new FormGroup({
      active: new FormControl(true),
      code: new FormControl('', Validators.required),
      name: new FormControl(this.data && this.data.nameCompany ? this.data.nameCompany : '', Validators.required)
    })
  }

  onSubmit() {
    if (this.utils.errorMessagesCustomized(this.form.get('code'), 'código')) return;
    else if (this.utils.errorMessagesCustomized(this.form.get('name'), 'nombre del centro')) return;
    else this.associateCostCenter(this.form.value);
  }

  private associateCostCenter(costCenter: CostCenter): void {
    this.spinner.show();
    this.companiesService.associateCostCenter(costCenter, this.data.nitCompany, this.data.transportCompanyId).toPromise()
      .then((response) => {
        this.spinner.hide();
        if (this.companiesService.isAssociateCostCenterSuccess(response)) {
          // La respuesta es la lista actualizada de asociados: de ahí sale el creado (con su id); si no, el enviado.
          const costCenters = this.companiesService.costCentersFromResponse(response);
          const created = costCenters ? costCenters.find(costCenterResponse => costCenterResponse.code === costCenter.code) : null;
          this.snackBarService.openSnackBar(Fmt.string(ServiceMessages.STATE_COST_CENTER, 'asociado'));
          this.dialogRef.close({ state: true, data: created || costCenter, costCenters });
        } else {
          this.snackBarService.openSnackBar(this.companiesService.costCenterResponseMessage(response), undefined, 'error');
          this.dialogRef.close();
        }
      })
      .catch((error) => {
        this.spinner.hide();
        this.snackBarService.openSnackBar('Ocurrió un error al enviar la información', undefined, 'error');
        this.dialogRef.close();
      });
  }



}
